import { render } from "./MdvBlogCard.vue?vue&type=template&id=73206282&scoped=true"
import script from "./MdvBlogCard.vue?vue&type=script&lang=js"
export * from "./MdvBlogCard.vue?vue&type=script&lang=js"

import "./MdvBlogCard.vue?vue&type=style&index=0&id=73206282&scoped=true&lang=css"

import exportComponent from "C:\\Users\\sciam\\Desktop\\Workspaces\\local\\workspace_vue\\mdv-webapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73206282"]])

export default __exports__